import {ProductCardSkeleton} from "@screens/ShopPage/components/ProductCardSkeleton.tsx";

export const ShopFormulaSkeleton = () => {
  return (
    <div className="container flex flex-col md:flex-row gap-8 p-4">
      <div className="md:w-5/12 space-y-4">
        <div className="h-10 bg-gray-300 rounded w-full animate-pulse"/>
        <div className="h-4 bg-gray-300 rounded w-2/4 animate-pulse"/>
        <div className="h-8 bg-gray-300 rounded w-full animate-pulse"/>
        <div className="h-12 bg-gray-300 rounded w-2/4 animate-pulse !mt-6"/>
      </div>
      <div className="md:w-7/12 space-y-4">
        <div className="flex justify-between items-center mb-4">
          <div className="h-8 bg-gray-300 rounded w-2/4 animate-pulse"/>
        </div>
        <ProductCardSkeleton/>
        <ProductCardSkeleton/>
        <ProductCardSkeleton/>
        <ProductCardSkeleton/>
      </div>
    </div>
  )
}